module.exports = __webpack_public_path__ + "static/media/firefox_logo.edf69d10.svg";